import {Box, Chip, Stack, Typography} from "@mui/material";
import {AMBIENTE} from "../../shared/env";
import {obterAmbienteAplicacao} from "../../shared/modoAplicacao";
import useSessao from "../../shared/useSessao";

export default function IdentificacaoSessao({showEnvironment = true}) {
    const session = useSessao();
    return (
        <Stack
            direction={{xs: "column", sm: "row"}}
            spacing={0.5}
            alignItems={{xs: "flex-start", sm: "center"}}
            sx={{minWidth: 0}}
            aria-label="Identificação da sessão"
        >
            <Box sx={{minWidth: 0, overflowWrap: "anywhere"}}>
                <Typography
                    variant="body2"
                    fontWeight={600}
                    noWrap
                    title={session.user?.name}
                >
                    {session.user?.name ||
                        (session.localMock
                            ? "Simulação local sem autenticação"
                            : "Usuário não autenticado")}
                </Typography>
                {session.user?.username &&
                    session.user.username !== session.user.name && (
                        <Typography
                            variant="caption"
                            component="div"
                            noWrap
                            title={session.user.username}
                        >
                            {session.user.username}
                        </Typography>
                    )}
            </Box>
            {showEnvironment && (
                <Chip
                    size="small"
                    variant="outlined"
                    label={`Ambiente: ${
                        obterAmbienteAplicacao(AMBIENTE).rotulo
                    }`}
                    sx={{
                        color: "inherit",
                        borderColor: "divider",
                        maxWidth: "100%"
                    }}
                />
            )}
        </Stack>
    );
}
